import { defineComponent as _defineComponent } from 'vue'
import { Form } from 'element-ui';
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchBar',
  props: {
    noSearch: { type: Boolean },
    noReset: { type: Boolean },
    model: null,
    rules: null,
    hasBack: { type: Boolean }
  },
  emits: ["query", "reset"],
  setup(__props: any, { expose, emit: emits }: { emit: ({
    (e: 'query'): void
    (e: 'reset'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    noSearch?: boolean
    noReset?: boolean
    model?: any
    rules?: any
    hasBack?: boolean
}



function onQuery() {
    emits('query')
}

function onReset() {
    emits('reset')
}

const formRef = ref<Form>(null)

expose({
    formRef
})



return { __sfc: true,props, emits, onQuery, onReset, formRef }
}

})